export default __webpack_public_path__ + "static/media/set11.11638f00.jpeg";